import { MediaUploadConfig } from '../utils/file.util';

/**
 * Default media upload configuration for File Manager
 * Supports both regular files and zip files
 */
export const DEFAULT_FILE_MANAGER_UPLOAD_CONFIG: MediaUploadConfig = {
  multiple: true,
  maxFiles: undefined, // No limit
  maxFileSize: 100 * 1024 * 1024, // 100MB max file size
  allowedFileTypes: undefined, // Allow all file types including zip
};
